import type { DocParts } from '../internal';
import { isDocumentElement, isFootersElement, isHeadersElement } from '../internal';

/**
 * `documentJSON` is an untyped JSON scalar. Find each part by type (order is
 * not guaranteed) before handing them to an exporter.
 */
export function toDocParts(documentJSON: unknown): DocParts | null {
  if (!Array.isArray(documentJSON)) return null;

  const documentElement = documentJSON.find(isDocumentElement);
  const headersElement = documentJSON.find(isHeadersElement);
  const footersElement = documentJSON.find(isFootersElement);
  if (!documentElement || !headersElement || !footersElement) return null;

  return [documentElement, headersElement, footersElement];
}
